export const buildNumber = '20260831.4';
export const version = 'main';
export const latestCommit = '3fb5c02231a40fa682febd334852b4ef3b15fe33';
